import React, { useState, useEffect } from "react";
import { Wrapper,Content } from "./SearchBar.styles";
import searchIcon from '../../images/search-icon.svg';


const SearchBar = ({setSearchValue})=>{

    const [state,setState] = useState("");
  
    useEffect(()=>{
      const timer = setTimeout(()=>{
        setSearchValue(state)
      },500)
  
      return ()=> clearTimeout(timer)
    },[setSearchValue,state])
  
    return(
       <Wrapper>
        <Content>
          <img src={searchIcon}/>
          <input 
            type="text" 
            placeholder='Search'
            onChange={event => setState(event.currentTarget.value)}
            value={state}  
            />
        </Content>
  
       </Wrapper>
  
    );
  
  };

export default SearchBar